const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * SEARCH EVENTS                                                              *
 * -------------                                                              *
 * - Search most serched term clicked                                         *
 * - Search query inserted                                                    *
 * - Search with no result                                                    *
 * - Search session used                                                      *
 * - Search tooltip loaded/clicked                                            *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Search most serched term clicked
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.searchMostSearchedClicked,
    (term) => {
      pushEvent(
        createCustomEventGA4('top_search', [
          ['top_search_suggested', term],
        ]),
      );
    },
  );

  // Search query inserted
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.searchQueryInserted,
    (payload) => {
      pushEvent(
        createCustomEventGA4('search', [
          ['search_term', payload.search.query],
        ]),
      );
    },
  );

  // Search with no result
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.searchReturnedNoResults,
    (payload) => {
      pushEvent(
        createCustomEventGA4('search_without_results', [
          ['keyword', payload.query],
        ]),
      );
    },
  );

  // Search session used
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.searchSessionUsed,
    (type) => {
      pushEvent(
        createCustomEventGA4('search_session', [
          ['search_engine_type', type],
        ]),
      );
    },
  );

  // Search tooltip loaded/clicked
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.searchTooltipLoaded,
    (item) => {
      pushEvent(
        createCustomEventGA4('search_tooltip', [
          ['item', item],
        ]),
      );
    },
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
